import { useContext, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { IPostingOfGoodsModel } from "../models/IPostingOfGoodsModel";
import { selectCompanyId } from "src/redux/slices/accountingReportSlice";
import { NewDocumentModalViewContext } from "src/components/Shared/NewDocumentModalView";
import { useAppSelector } from "src/redux/hooks/hooks";
import { selectSubmitCounter } from "src/redux/slices/submitCounterSlice";
import useRunError from "src/components/Shared/useRunError";
import { useFetchPostingOfGoods } from "../hooks/fetchDocument";
import { NFTabs } from "src/components/Shared/NewForms/NFTabs";
import { NFTab } from "src/components/Shared/NewForms/NFTab";
import DocumentDetailViewToolbar from "src/components/Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "src/components/Shared/DetailViews/DetailViewPostButton";
import DetailViewCancelButton from "src/components/Shared/DetailViewCancelButton";
import { NFTabContainer } from "src/components/Shared/NewForms/NFTabContainer";
import { PostingOfGoodsDetailMain } from "./PostingOfGoodsDetailMain";
import { PostingOfGoodsDetailProducts } from "./PostingOfGoodsDetailProducts";
import { PostingOfGoodsDetailAdditional } from "./PostingOfGoodsDetailAdditional";
import { PostingOfGoodsDetailFooter } from "./PostingOfGoodsDetailFooter";

interface IProps {
  id?: string;
}

export const PostingOfGoodsDetail = ({id}: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<IPostingOfGoodsModel>();
  const companyId = useSelector(selectCompanyId);

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;

  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Posting Of Goods");
  const counter = useAppSelector(selectSubmitCounter);
  const runError = useRunError(isValid, errors, counter);
  useEffect(() => {
    if (errors.companyId?.type === "required" || errors.warehouseId?.type === "required" || errors.divisionId?.type === "required") {
      runError();
    }
  }, [errors, runError]);

  useEffect(() => {
    localStorage.setItem("companyId", JSON.stringify(companyId));
  }, [companyId]);

  const { isDocumentLoading, documentModel, postDocument, cancelDocument, updateDocument } = useFetchPostingOfGoods({ documentId: id });

  useEffect(() => {
    if (documentModel) {
      reset(documentModel);
    }
  }, [documentModel]);

  useEffect(() => {
    if (formState.isDirty) {
      console.log("formState.isDirty", formState.isDirty);
      updateDocument(getValues());
    }
  }, [formState.isDirty]);

  const handlePost = async () => {
    await postDocument();
  };

  const handleCancel = async () => {
    await cancelDocument();
  };

  // const exportToExcel = () => {
  //   const data = {
  //     ...model
  //   };
  //   const documentInfo = {
  //     title: AppEntities.PostingOfGoods.title,
  //     number: model.documentNumber,
  //     date: model.documentDate
  //   };
  //   saveObjectToExcel(data, documentInfo);
  // };

  // const handleUploadFile = (file: File) => {
  //   importFromExcel(file, (data: any) => {
  //     reset(data);
  //   });
  // };

  return (
    <>
      <FormProvider
        getValues={getValues}
        setValue={setValue}
        register={register}
        control={control}
        trigger={trigger}
        reset={reset}
        watch={watch}
        handleSubmit={handleSubmit}
        formState={formState}
        {...methods}
      >
        <NFTabs
          onTabChange={(newIndex) => {
            setTabIndex(newIndex);
          }}
        >
          <NFTab title={"Main"} />
          <NFTab title={"Products"} />
          <NFTab title={"Additional"} />
        </NFTabs>

        <div className={"modal-container-height"}>

          <DocumentDetailViewToolbar>
            <DetailViewPostButton onPost={handlePost} />
            <DetailViewCancelButton onCancel={handleCancel} />
          </DocumentDetailViewToolbar>

          <NFTabContainer index={0} currentIndex={tabIndex}>
            <PostingOfGoodsDetailMain />
          </NFTabContainer>

          <NFTabContainer index={1} currentIndex={tabIndex}>
            <PostingOfGoodsDetailProducts />
          </NFTabContainer>

          <NFTabContainer index={2} currentIndex={tabIndex}>
            <PostingOfGoodsDetailAdditional />
          </NFTabContainer>
          <PostingOfGoodsDetailFooter />
        </div>
      </FormProvider>
    </>
  );
};
